import React from 'react'

const QUOTES = [
    { text: "I wish there was a way to know you're in the good old days before you've actually left them.", source: "Andy Bernard - The Office." },
    { text: "It gets easier. Every day it gets a little easier. But you gotta do it every day — that's the hard part.", source: "Jogging Baboon - BoJack Horseman." },
    { text: "It's possible to commit no mistakes and still lose. That's not a weakness, that's life.", source: "Captain Jean-Luc Picard - Star Trek." },
    { text: "You are the average of the five people you spend the most time with.", source: "Jim Rohn." },
    { text: "Luck is when preparation meets opportunity.", source: "Seneca." }
]

// Picked once per visit: stays the same across re-renders and page changes
const SESSION_QUOTE = QUOTES[Math.floor(Math.random() * QUOTES.length)]

export const Quote = () => {
    const quote = SESSION_QUOTE;

    return (
        <div className='text-stone-800 dark:text-white'>
            <div className='italic text-sm xl:text-2xl 2xl:text-3xl'>" {quote.text} "</div>
            <div className='text-xs text-right xl:text-xl 2xl:text-2xl'>{quote.source}</div>
        </div>
    ) 
}
